// Component: Toolbar.jsx
// Purpose: DS Toolbar — Slot 2 "Controls" of the page archetype
//          (design-system/ui_kits/app/pages/_archetypes.html). A flat,
//          bordered-bottom row holding the page's tabs on the left (scrollable)
//          and a right cluster of view-scoped filters + the single accent
//          primary CTA. Props-based so the right cluster wraps as ONE unit on
//          narrow screens instead of filters/actions breaking to separate rows.
//
//          Scope rule: only VIEW-scoped controls belong here. Page-GLOBAL
//          filters (time range, mode, view density) go in the PageHeader
//          `actions` slot (Tier 1), not the Toolbar.
//
// Usage:
//   <Toolbar
//     nav={<GroupTabs … />}
//     filters={<Segmented … />}
//     actions={<Button variant="accent">…</Button>}  // md — stays on the 32px rail
//   />

import React from "react";
import { cx } from "./cx";

export const Toolbar = ({ nav, filters, actions, className, ...props }) => (
  <div className={cx("ds-toolbar", className)} {...props}>
    <div className="ds-toolbar-nav">{nav}</div>
    {(filters || actions) && (
      <div className="ds-toolbar-right">
        {filters && <div className="ds-toolbar-filters">{filters}</div>}
        {actions && <div className="ds-toolbar-actions">{actions}</div>}
      </div>
    )}
  </div>
);

export default Toolbar;
